<!-- Do not change this file. -->
<template>
  <div class="text-start card shadow-sm border-1 border-primary shadow-sm">
    <div class="card-header border-primary bg-primary-subtle fw-bold">
      {{ fullname }}<span> ({{ onid }})</span>
    </div>
    <div class="card-body">
      <slot></slot>
    </div>
    <div class="card-footer text-end">
      <button
        class="btn btn-sm btn-link text-decoration-none text-danger"
        @click="deleteData"
      >
        <i class="bi bi-trash me-2"></i>Reset Data
      </button>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

export default {
  name: "AdminActiveEntry",
  props: {
    activeEntryData: Object,
    fullname: String,
    onid: String
  },
  methods: {
    deleteData() {
      if (confirm("Are you sure?")) {
        console.log("Deleted");
      }
    }
  }
};
</script>

<style scoped>
.hover {
  cursor: pointer;
}
</style>
